'use client';

import { motion } from 'framer-motion';

interface ServiceLayoutProps {
    children: React.ReactNode;
}

export default function ServiceLayout({ children }: ServiceLayoutProps) {
    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5, delay: 0.0 }}
                className="flex flex-col justify-start items-start w-full h-full overflow-y-hidden overflow-x-hidden"
            >
                <div className="flex flex-shrink-0 justify-start items-start p-4 bg-color-light-gray min-w-full min-h-full">
                    <div className="flex flex-col justify-start items-center rounded-md w-full h-full bg-color-white-base/80 shadow-right-bottom">
                        {children}
                    </div>
                </div>
            </motion.div>
        </>
    );
}
